angular.module('impactx.demand').controller('DemandListCtrl', ['dataGen', 'selectedListItems', 'basketTemplateMenu', '$redirect', '$mdDialog',
    '$context', 'ToastService', 'TemplateNameService',
    function (dataGen, selectedListItems, basketTemplateMenu, $redirect, $mdDialog, $context, ToastService, TemplateNameService) {
        var ctrl = this;

        this.cancelItems = function() {
            var newScope = {};
            dataGen.getData(newScope, {selected: [selectedListItems.getSelectedItems()]}, '/demand/cancellation/view').then(function(data) {
                if(data.errors.length < 1) {
                    $redirect.redirectTo(null, "/canceldemand", selectedListItems.getSelectedItems());
                }
            });
        };

        this.createBasketTemplate = function() {
            TemplateNameService.showTemplateName(selectedListItems.getSelectedItems(), '/basket/template/beforecreatefromdemand', event).then(function(answer){
                if(answer)
                {
                    dataGen.postAsForm({}, {items: selectedListItems.getSelectedItems(), name: answer}, '/basket/template/createfromdemand').then(function()
                    {
                        basketTemplateMenu.refreshAllTemplates();
                    });
                }
            });
        }

        this.getDetailLink = function() {
            return "demanddetail/" + selectedListItems.getFirstSelectedId();
        };

        this.showCancelButton = function() {
            return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCancel;
        };

        this.cancelAll = function(event) {
            $mdDialog.show({
                controller: "CancelAllDemandCtrl",
                controllerAs: "cancelAllCtrl",
                templateUrl: "modules/cancellation/templates/cancellation-all.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    selectedEntries: selectedListItems.getSelectedItems()
                }
            })
        };

        this.addToCurrentBasket = function(ev) {
            $mdDialog.show({
                controller: "AddToBasketOrderController",
                controllerAs: 'ctrl',
                templateUrl: 'modules/basket/templates/add-to-basket-config.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    multipleSelection: selectedListItems.getSelectedItems().length > 1
                }
            }).then(function (answer) {
                if (answer) {
                    var scope = {};
                    dataGen.postAsForm(scope, {items: selectedListItems.getSelectedItems(), config: answer}, '/demand/addtobasket').then(function () {
                        $context.refreshBasket({}, dataGen, $context);
                        ToastService.openStandardToast(scope.trns.addToCurrentBasketSuccess);
                    }, function () {
                        $context.refreshBasket({}, dataGen, $context);
                    });
                }
            })
        };

        this.canAddToBasket = function()
        {
            var selected = selectedListItems.getSelectedItems();
            if (selected.length > 0) {
                for (var i = 0; i < selected.length; i++) {
                    if (!selected[i].canAddToBasket.value) {
                        return false;
                    }
                }
                return true;
            }
            else {
                return false;
            }
        };

        var buttonDefinition = [
            {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'Demand'},
            {label: "createTemplate", action: ctrl.createBasketTemplate, condition:  selectedListItems.isMultiSelection, process: 'AddTemplateToBasket'},
            {label: "cancel", action: ctrl.cancelItems, condition:  ctrl.showCancelButton, process: 'Demand'},
            {label: "cancelAll", action: ctrl.cancelAll, condition:  ctrl.showCancelButton, process: 'Demand'},
            {label: "addToBasket", action: ctrl.addToCurrentBasket, condition: ctrl.canAddToBasket, process: 'AddTemplateToBasket'}
        ];

        this.meta = {
            rowTemplate: 'modules/status/demand/templates/demandlist.row.tmpl.html',
            isSelectAble: true,
            endpoint: '/demand/list',
            ctrl: this,
            id: "demand",
            buttonDefinition: buttonDefinition
        };
        this.getMeta = function ()
        {
            return this.meta;
        };
    }
    ]);